export enum InvoiceCustomForm {
  AssignToEntryUserAndSend = 'AssignToEntryUserAndSend',
  GenerateInvoiceEmailModal = 'GenerateInvoiceEmail',
  ReceiveInvoicePayment = 'ReceiveInvoicePayment',
  UpdateInvoiceSentDate = 'UpdateInvoiceSentDate',
}
